import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IForwardRule } from "../shared/interfaces";

const controller = 'ForwardRules';



const getAllForwardRulesInAoo = (aooId: number, cancelToken?: CancelToken): Promise<IForwardRule[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetAllForwardRulesInAoo`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getFilteredForwardRulesInAoo = (aooId: number, filter: Partial<IForwardRule>, cancelToken?: CancelToken): Promise<IForwardRule[]> => {
    return axiosInstance.post(`${controller}/${aooId}/GetFilteredForwardRulesInAoo`, filter, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getForwardRule = (aooId: number, forwardRuleId: number, cancelToken?: CancelToken): Promise<IForwardRule> => {
    return axiosInstance.get(`${controller}/${aooId}/Get/${forwardRuleId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const addMultiForwardRule = (aooId: number, forwardRules: Partial<IForwardRule>[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/AddMulti`, forwardRules, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}
const addForwardRule = (aooId: number, forwardRule: Partial<IForwardRule>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/Add`, forwardRule, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateForwardRule = (aooId: number, forwardRule: Partial<IForwardRule>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/${aooId}/Update`, forwardRule, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteForwardRule = (aooId: number, forwardRuleId: number,  cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/Delete/${forwardRuleId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getAllForwardRulesInAoo,
    getFilteredForwardRulesInAoo,
    getForwardRule,
    addMultiForwardRule,
    addForwardRule,
    updateForwardRule,
    deleteForwardRule

}